import React, { useState } from 'react';

import _ from 'lodash';
//MUI
import {
	Box,
	List,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Stack,
	Typography,
	useTheme,
} from '@mui/material';
//Hooks
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';

//Services
import { logOut } from 'services/auth.service';
//styles
import { IconButton } from 'theme/layouts/sidebar';
import { getUserDetails } from 'state/reducers/user.reducers';
import { ProfileAvatar } from 'theme/layouts/navbar';

interface IProps {
	open: boolean;
	profileSubmenuOpen: boolean;
	handleProfileIconClick: any;
}
export const ProfileComponent: any = ({ open, profileSubmenuOpen, handleProfileIconClick }: IProps) => {
	const { firstName, email, phone, role, permissions } = useAppSelector(getUserDetails);
	const theme = useTheme();
	const dispatch = useAppDispatch();

	const userRole = role ? `תפקיד - ${role}` : '';
	const userPermissions = permissions?.groups?.length ? `הרשאה - ${permissions?.groups?.toString()}` : '';
	const userData = [email, phone, userRole, userPermissions].filter((value) => value !== undefined && value);
	return (
		<Box
			sx={{
				backgroundColor: profileSubmenuOpen
					? theme.palette.root.sideBarHoverGreen
					: theme.palette.root.basicDeeoGreen,
			}}
		>
			{profileSubmenuOpen && (
				<Box
					sx={{
						color: theme.palette.root.basicWhite,
						backgroundColor: theme.palette.root.sideBarHoverGreen,
						padding: '0 8%',
					}}
				>
					<List>
						{userData.map((userData) => (
							<ListItem key={userData}>
								<ListItemText primary={userData} />
							</ListItem>
						))}
						<ListItem>
							<ListItemButton
								sx={{
									'&:hover': { backgroundColor: theme.palette.root.sideBarHoverGreen },
									padding: '0',
								}}
								onClick={() => {
									dispatch(logOut());
								}}
							>
								<ListItemIcon>
									<img src={'/icons/logout.svg'} style={{ filter: 'brightness(0) invert(1)' }} />
								</ListItemIcon>
								<ListItemText primary="התנתקות" />
							</ListItemButton>
						</ListItem>
					</List>
				</Box>
			)}
			<Stack
				direction="row"
				spacing={3}
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: open ? 'flex-start' : 'center',
					padding: '15px 26px',
				}}
			>
				<IconButton
					className="desktop-item"
					id="basic-button"
					aria-haspopup="true"
					sx={{
						height: 'fit-content',

						display: 'flex',
						justifyContent: !open ? 'center' : 'unset',
						alignContent: !open ? 'center' : 'unset',
						'&:hover': { cursor: 'pointer' },
					}}
					onClick={handleProfileIconClick}
				>
					<ProfileAvatar>{_.upperCase(firstName[0])}</ProfileAvatar>
				</IconButton>
				{open && (
					<Stack spacing={1}>
						<Typography variant="body" color={theme.palette.root.basicWhite}>
							{firstName || ''}
						</Typography>
					</Stack>
				)}
			</Stack>
		</Box>
	);
};
